module.exports = __webpack_public_path__ + "img/purchase2.b90fc96a.jpg";